import React, { ReactNode } from 'react';
import styles from './CustomText.module.css';

type CustomTextType = {
    children: ReactNode,
    bold?: boolean,
    className?: string;
}

const CustomText = (props: CustomTextType) => {
    return (
        <p
            className={`${styles.text} ${props.className}`}
            style={{ fontWeight: props.bold ? 'bold' : 'normal' }}
        >
            { props.children }
        </p>
    );
}

export default CustomText;